'use strict';

var $BigInt = typeof BigInt !== 'undefined' && BigInt;

module.exports = function hasNativeBigInts() {
	return typeof $BigInt === 'function'
		&& typeof BigInt === 'function'
		&& typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
		&& typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};



//////////////////
// WEBPACK FOOTER
// ./~/has-bigints/index.js
// module id = 74
// module chunks = 20216485166878 72576805601409 114276838955818 211741474912242 256957939565513